const prefix = 'data-table';

export const i18n = {
    noResultsTitle: {
        id: `${prefix}.noResultsTitle`,
        defaultMessage: 'No results',
    },
    noResultsMessage: {
        id: `${prefix}.noResultsMessage`,
        defaultMessage: 'There are no items to display.',
    },
    loadingMore: {
        id: `${prefix}.loadingMore`,
        defaultMessage: 'Loading more…',
    },
    loadedOfTotal: {
        id: `${prefix}.loadedOfTotal`,
        defaultMessage: 'Showing {loaded, number} of {total, number} records',
    },
    searchPlaceholder: {
        id: `${prefix}.searchPlaceholder`,
        defaultMessage: 'Search…',
    },
    expandRow: {
        id: `${prefix}.expandRow`,
        defaultMessage: 'Expand row',
    },
    collapseRow: {
        id: `${prefix}.collapseRow`,
        defaultMessage: 'Collapse row',
    },
} as const;
